<template>
	<div>
		<filter-panel :data="featureGroups" @search="filterChange"></filter-panel>
		<div class="button-area">
			<el-button class="feature-btn" type="primary" @click="addFeature">新增</el-button>
		</div>
		<data-list
			:data="data"
			:columns="featureColumn"
			:table-style="{ name: 'mixture' }"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<!-- 模态框 -->
		<dialog-form
			ref="dialogForm"
			:dialogVisible.sync="dialogVisible"
			:formData="formData"
			:attributes="attributes"
			@close:dialogVisible="close"
			@confirm="confirm"
		></dialog-form>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import dialogForm from '@/components/dialogForm/dialogForm';
import inputMessage from '@/components/SaaS/inputMessage';
import currencyAdd from '@/components/SaaS/currencyAdd';
// import selectMessage from '@/components/SaaS/selectMessage';
import { oneHundred, validRequired, oneHundredDecimal } from '@/common/elementValid.js';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import setmeal from '@/backend/services/account/setmeal.js';
import { featureUnit, billingPeriodType } from '@/common/dictionary.js';
const list = listPageCreate({
	searchConfig: {
		api: api.setmeal.featureList,
		method: 'POST',
	},
});

// 价格校验
var validatorPrice = (_rule, value, callback) => {
	let obj = value.find(item => {
		return !item.currency;
	});

	if (obj) return callback(new Error('请选择币种'));

	callback();
};

export default {
	mixins: [list],
	props: ['featureGroups', 'featureColumn'],
	data() {
		return {
			dialogVisible: false,
			attributes: {
				width: '40%',
				confirmBtn: '确定',
				labelWidth: '180px',
			},
			formData: {},
			showDateTime: false,
			showDusiness: false,
			preFunctionItemList: '',
			update: false,
			updateId: '',
			businessLineId: '',
			featureType: [],
			featurePermissions: [],
		};
	},
	created() {
		this.getFunctionItemsTypeList();
		this.getAffiliatedPermissionsList();
	},
	methods: {
		// 获取挂靠权限列表
		async getAffiliatedPermissionsList() {
			let { data } = await setmeal.affiliatedPermissionsList();
			this.featurePermissions = data;
		},
		// 获取功能列表
		async getFunctionItemsTypeList() {
			let { data } = await setmeal.functionItemsTypeList();
			this.featureType = data;
		},
		addFeature() {
			this.update = false;
			this.getActiveFeatureList();
		},
		confirm(callback) {
			let port, type;
			if (this.update) {
				// 更新
				port = `${api.setmeal.featureUpdate}/${this.updateId}`;
				type = 'Patch';
			} else {
				// 保存
				port = api.setmeal.addFeature;
				type = 'Post';
			}
			// 保存
			simpleFormPageCreate(
				{
					api: port,
					type,
					data: this.formData,
				},
				res => {
					Object.keys(res).forEach(item => {
						if (res[item] === '') {
							delete res[item];
						}
					});
					return res;
				}
			)
				.submit()
				.then(() => {
					this.query();
					callback && callback();
				})
				.catch(() => {
					this.$refs.dialogForm.btnLoading = false;
				});
		},
		close(val) {
			this.dialogVisible = val;
			this.showDateTime = false;
			this.showDusiness = false;
		},
		async getActiveFeatureList(val, id) {
			// let res = await setmeal.activeFeatureList();
			let data = await setmeal.businessLine(200);
			// this.preFunctionItemList = res.data;
			this.businessLineId = data.data;
			// 更新
			if (val) {
				this.update = true;
				this.updateId = id;
				this.attributes.confirmBtn = '更新';
				this.showDateTime = val.isImmediatelyToEnable;
				if (val.type == 3 || val.type == 7 || val.type == 22 || val.type == 23) {
					this.showDusiness = true;
				} else {
					this.showDusiness = false;
				}
			} else {
				this.update = false;
				this.updateId = '';
				this.attributes.confirmBtn = '确定';
			}

			this.setFormData(val);
		},
		setFormData(val = {}) {
			let that = this;
			this.formData = {
				name: {
					label: '功能名称',
					formType: 'sky-input',
					value: val.name,
					rules: [validRequired()],
				},
				type: {
					label: '功能类型',
					formType: 'sky-select',
					options: that.featureType,
					value: val.type,
					disabled: that.update,
					rules: [validRequired()],
					props: { label: 'name', value: 'id' },
					change(val) {
						if (val == 3 || val == 7 || val == 22 || val == 23) {
							that.showDusiness = true;
							that.formData.isOpenAnAccount.value = true;
							that.formData.isOpenAnAccount.disabled = false;
						} else {
							that.showDusiness = false;
							that.formData.isOpenAnAccount.value = false;
							that.formData.isOpenAnAccount.disabled = true;
						}
					},
				},
				businessLineId: {
					label: '业务线',
					formType: 'sky-select',
					options: that.businessLineId,
					props: {
						label: 'name',
						value: 'code',
					},
					value: val.businessLineId,
					rules: [validRequired()],
					displayWith() {
						return that.showDusiness;
					},
				},
				affiliatedPermissionsList: {
					label: '挂靠权限',
					formType: 'sky-select',
					props: { label: 'name', value: 'id' },
					multiple: true,
					options: that.featurePermissions,
					value: val.affiliatedPermissionsList,
				},
				billingPeriodType: {
					label: '入账期',
					formType: 'sky-select',
					options: billingPeriodType,
					value: val.billingPeriodType,
					rules: [validRequired()],
				},
				unit: {
					label: '计算单位',
					formType: 'sky-radio',
					options: featureUnit,
					value: val.unit,
					rules: [validRequired()],
				},
				number: {
					label: '量/时间',
					formType: 'sky-input',
					value: val.number,
					rules: [validRequired()],
				},
				priceList: {
					label: '价格',
					type: 'custom',
					formType: currencyAdd,
					message: '人民币',
					value: val.priceList || [
						{
							price: 0,
							currency: 127001,
						},
					],
					rules: [validRequired(), { validator: validatorPrice, trigger: 'blur' }],
				},
				rebateProportion: {
					label: '返点比例',
					type: 'custom',
					formType: inputMessage,
					message: '仅可填写0~100的数值',
					value: val.rebateProportion,
					rules: [oneHundredDecimal()],
				},
				serviceChargeProportion: {
					label: '服务费比例',
					type: 'custom',
					formType: inputMessage,
					message: '仅可填写0~100的整数',
					value: val.serviceChargeProportion,
					rules: [oneHundred(), validRequired()],
					displayWith(formData) {
						return formData.type.value != 8 && formData.type.value != 9;
					},
				},
				taxesProportion: {
					label: '税费比例',
					type: 'custom',
					formType: inputMessage,
					message: '仅可填写0~100的整数',
					value: val.taxesProportion,
					rules: [oneHundred(), validRequired()],
					displayWith(formData) {
						return formData.type.value != 8 && formData.type.value != 9;
					},
				},
				// preFunctionItemList: {
				// 	label: '前置条件功能',
				// 	formType: 'sky-select',
				// 	options: that.preFunctionItemList,
				// 	valueKey: 'id',
				// 	props: {
				// 		label: 'name',
				// 		value: 'id',
				// 	},
				// 	multiple: true,
				// 	// message: '非系统类【功能类型】-前置条件不能为空',
				// 	value: val.preFunctionItemList,
				// },
				isImmediatelyToEnable: {
					label: '是否立即启用',
					formType: 'sky-switch',
					value: val.isImmediatelyToEnable || false,
					change(val) {
						that.showDateTime = val;
					},
				},

				taskFlowFlag: {
					label: '是否选择任务流',
					formType: 'sky-switch',
					value: val.taskFlowFlag || false,
				},
				addFlag: {
					label: '允许新增',
					formType: 'sky-switch',
					value: val.addFlag || false,
				},
				isAllowRenewal: {
					label: '允许续费',
					formType: 'sky-switch',
					value: val.isAllowRenewal || false,
				},
				changeFlag: {
					label: '允许变更',
					formType: 'sky-switch',
					value: val.changeFlag || false,
				},
				selfPlaceOrderFlag: {
					label: '允许客户自主下单',
					formType: 'sky-switch',
					value: val.selfPlaceOrderFlag || false,
				},
				superpositionFlag: {
					label: '允许叠加',
					formType: 'sky-switch',
					value: val.superpositionFlag || false,
				},

				isOpenAnAccount: {
					label: '是否开户',
					formType: 'sky-switch',
					disabled: !that.showDusiness,
					value: val.isOpenAnAccount || false,
					displayWith() {
						return that.showDusiness;
					},
				},

				enableTime: {
					label: '启用日期',
					formType: 'sky-date-picker',
					type: 'datetime',
					valueFormat: 'yyyy-MM-dd HH:mm:ss',
					value: val.enableTime,
					rules: that.showDateTime ? [] : [validRequired()],
					displayWith() {
						return !that.showDateTime;
					},
					pickerOptions: {
						disabledDate(time) {
							return time.getTime() < new Date().getTime();
						},
					},
				},
				remarks: {
					label: '备注',
					formType: 'sky-textarea',
					'show-word-limit': true,
					rows: 4,
					value: val.remarks,
				},
			};
			this.dialogVisible = true;
		},
	},
	components: { filterPanel, dialogForm },
};
</script>

<style lang="scss" scoped>
.button-area {
	width: 100%;
	height: 60px;
	margin: 10px 0;
	padding: 0 20px;
	padding-bottom: 10px;
	background-color: #fff;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
}
</style>
